var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{attrs:{"min":_vm.min,"max":_vm.fMax,"step":_vm.step,"size":_vm.size,"label":_vm.label,"controls":_vm.controls,"precision":_vm.precision,"disabled":_vm.disabledValue,"placeholder":_vm.placeholder},on:{"change":_vm.change},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }